import { c as _c } from "react/compiler-runtime";
import Box from '@classify/react-core-components/Box';
import Loader from '@classify/react-core-components/Loader';
import { translate } from '@openclassrooms/translations';
const LoadingState = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={t0}><Loader aria-label={translate("global.word.loading")} /></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default LoadingState;